import { ScheduleBlock, ScheduleBlockItem } from '@/tools/models/class-builder.models';

import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-class-schedule-sidebar',
  components: {
    EdBlockItem: () => import(/* "EdBlockItem" */ '../ed-block-item/ed-block-item.component.vue'),
  },
})
export default class EdClassScheduleSidebarComponent extends Vue {
  @Prop({ default: false }) readonly isAddingBlocks: boolean;
  @Prop({ default: null }) readonly blockToEdit: ScheduleBlockItem;
  @Prop({ default: () => [] }) readonly blocksCreated: ScheduleBlock[];
  @Prop({ required: true }) readonly isToggleSidebar: boolean;
  @Prop({ required: true }) readonly isAbleToModify: boolean;

  get message() {
    if (this.blocksCreated.length > 0) {
      return this.$i18n.t('classes.schedule.sidebarMessageWithBlocks') as string;
    }

    return this.$i18n.t('classes.schedule.sidebarMessageWithoutBlocks') as string;
  }

  @Emit('onSelectActivated')
  emitOnSelectActivated(canSelect: boolean) {
    return { canSelect };
  }

  @Emit('onEditBlockSelected')
  emitOnEditBlockSelected(block: ScheduleBlock) {
    return block;
  }

  @Emit('onDeleteBlockSelected')
  emitOnDeleteBlockSelected(block: ScheduleBlock) {
    return block;
  }

  @Emit('onToggleSidebar')
  toggleSidebar() {
    return !this.isToggleSidebar;
  }

  @Emit('onDone')
  emitOnDone() {
    return;
  }
}